import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { useState } from "react"
import { usePolicyAndFleet } from "../../contexts"
import { LowConnectivityBanner } from "../../ui/components/LowConnectivityBanner"
import { EditCoverDatesModal } from "../edit/EditCoverDatesModal"
import { ConnectivityThresholdDialog } from "./ConnectivityThresholdDialog"
import { FleetListModern } from "./FleetListModern"
import { FleetListData } from "./fleetListHandlers"

export const FleetList: React.FC<RouteComponentProps> = () => {
  const { policy, fleet, connectivity } = usePolicyAndFleet()
  const { reload } = fleet

  const [isEditing, setIsEditing] = useState(false)
  const [selectedRows, setSelectedRows] = useState<ReadonlyArray<FleetListData>>([])

  // @Hack - because the FleetListModern makes its own api calls, calling reload here
  // wont make the Modern table reload.
  // We need to set a reload time onUpdateComplete, which will cause a re-render.
  const [reloadTime, setReloadTime] = useState<number | null>(null)

  const onUpdateComplete = () => {
    setIsEditing(false)
    setSelectedRows([])
    if (!policy.meta?.modern) {
      reload()
    } else {
      setReloadTime(new Date().getTime())
    }
  }

  return (
    <>
      {!!(connectivity.data || policy.connectivityRatio) && <LowConnectivityBanner policy={policy} />}
      <DocumentTitleOverride>Flock Motor | Fleet</DocumentTitleOverride>
      <FleetListModern
        setIsEditing={setIsEditing}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        reloadTime={reloadTime}
      />

      {/* // For now, this needs to be unrendered on reset, because date input does not reset it's value */}
      {isEditing && (
        <EditCoverDatesModal
          selectedRows={selectedRows}
          onDismiss={() => setIsEditing(false)}
          onUpdateComplete={onUpdateComplete}
        />
      )}
      {connectivity.data && (
        <ConnectivityThresholdDialog
          title="Disconnected vehicles detected"
          connectedTotal={connectivity.data.connectedVrns.length}
          disconnectedTotal={connectivity.data.onCoverTotal - connectivity.data.connectedVrns.length}
          isMatrixPolicy={false}
        />
      )}
    </>
  )
}
